/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_New_Round_TitleInputs */

const en_us2_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New round`)
};

const pt_br2_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova rodada`)
};

const es_419_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva ronda`)
};

const pt_pt2_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova ronda`)
};

const fr_fr2_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle manche`)
};

const de_de2_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Runde`)
};

const it_it2_clubs_new_round_title = /** @type {(inputs: Clubs_New_Round_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo turno`)
};

/**
* | output |
* | --- |
* | "New round" |
*
* @param {Clubs_New_Round_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_new_round_title = /** @type {((inputs?: Clubs_New_Round_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_New_Round_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_new_round_title(inputs)
	if (locale === "es-419") return es_419_clubs_new_round_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_new_round_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_new_round_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_new_round_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_new_round_title(inputs)
	return en_us2_clubs_new_round_title(inputs)
});
export { clubs_new_round_title as "clubs.new_round_title" }